import { OpenAPIPath } from '../OpenAPIPath';
import { OpenAPIStability } from './OpenAPIStability';
export function OpenAPISummary(props) {
    var _a;
    var data = props.data, context = props.context;
    var operation = data.operation;
    var title = (function () {
        if (operation.summary) {
            return operation.summary;
        }
        if ('name' in data) {
            return data.name;
        }
        return undefined;
    })();
    return (<div className="openapi-summary" id={operation.summary ? undefined : context.id}>
            {(operation.deprecated || operation['x-stability']) && (<div className="openapi-summary-tags">
                    {operation.deprecated && <div className="openapi-deprecated">Deprecated</div>}
                    {operation['x-stability'] && (<OpenAPIStability stability={operation['x-stability']}/>)}
                </div>)}
            {title
            ? context.renderHeading({
                deprecated: (_a = operation.deprecated) !== null && _a !== void 0 ? _a : false,
                stability: operation['x-stability'],
                title: title,
            })
            : null}
            {'path' in data ? <OpenAPIPath data={data} context={context}/> : null}
        </div>);
}
